import { ProductSlug } from "@/api/product-api";
import { CartItem } from "@/store/cart-store/type";

const MAX_QUANTITY = 4;

export class CartStoreUtils {
  /**
   * 조건에 맞는 아이템들의 수량 합계를 계산합니다
   */
  static sum(
    items: CartItem[],
    filter: (item: CartItem) => boolean,
    initialValue = 0,
  ): number {
    return items
      .filter(filter)
      .reduce((acc, item) => acc + item.quantity, initialValue);
  }

  /**
   * 특정 상품 슬러그의 수량 합계를 계산합니다
   */
  static sumBySlug(
    items: CartItem[],
    slug: ProductSlug,
    initialValue = 0,
  ): number {
    return CartStoreUtils.sum(
      items,
      (item) => item.slug === slug,
      initialValue,
    );
  }

  /**
   * 특정 SKU의 수량 합계를 계산합니다
   */
  static sumBySKU(items: CartItem[], sku: string, initialValue = 0): number {
    return CartStoreUtils.sum(items, (item) => item.sku === sku, initialValue);
  }

  /**
   * 아이템 수량 제한을 초과하는지 확인합니다.
   * 동일 SKU 기준으로 체크합니다.
   */
  static isOverItemLimit(
    currentItems: CartItem[],
    item: {
      sku: string;
      quantity: number;
    },
  ): boolean {
    const existing = CartStoreUtils.sumBySKU(currentItems, item.sku);
    return existing + item.quantity > MAX_QUANTITY;
  }

  /**
   * 최대 수량 상수를 반환합니다
   */
  static get MAX_QUANTITY(): number {
    return MAX_QUANTITY;
  }
}
